// extracted by mini-css-extract-plugin
export default {"root":"SmallWindowWarningDialog__root--1m5Cz"};